// computedでswiperオブジェクトのパスを短縮すると、複数のswiperがある関係上、うまく動かないので、ここでは短縮禁止
export default {
  data(){
    return {
      podRoomListSwiperOptions : {
        init              : false,
        slidesPerView     : 1,
        loop              : false,
        speed             : 800,
        freeModeMomentum  : false,
        pagination        : {
          el              : false,
        }
      },
    };
  },

  methods : {
    handleEnterSwiperThings(){
      this.$refs.podRoomListSwiper.$swiper.on('slideChange', () => {
        if(this.selectRoomId !== this.joinedPodRoomList[this.$refs.podRoomListSwiper.$swiper.activeIndex].id){
          this.$store.dispatch({
            type        : 'connection/updatePodRoomId',
            podRoomType : this.podRoomType,
            podRoomId   : this.joinedPodRoomList[this.$refs.podRoomListSwiper.$swiper.activeIndex].id
          });
        }
      });

      this.$refs.podRoomListSwiper.$swiper.init();
    }
  },

  mounted(){
    this.$on('handleEnter', this.handleEnterSwiperThings);
  }
}